import React, {useState,useEffect, useContext} from 'react';
import UserContext from './../contexts/UserContext';
import _ from 'lodash';
import axios from 'axios';
import Utils from './../Utils';
import {Card,Button,Container,Alert} from 'react-bootstrap';
import EditProfile from './EditProfile';

const ConfirmPay = (props) => {
  
  const {userData,setPackage, getPackage, selectedPackage} = useContext(UserContext);
  const [freePkg,setFreePkg] = useState({ name: 'Experimentation Package', discounted_amount: 0, scorm_count: 1,description: "1 Course"})
  const [loading, setLoading] = useState(false);
  const [buyPack,setBuyPack] = useState(getPackage(selectedPackage()));
  const checkPackageDetails = () => {
    setLoading('checking package details.. please wait..');
    axios.post(Utils.apiUrl('order/checkpkg'),{pkg: selectedPackage()},Utils.apiHeaders())
      .then(res => { 
        if(selectedPackage() === 'free'){
          Utils.addToUserData({pkg:freePkg});// set pkg object
          setPackage('free');
        }else{
          Utils.addToUserData({pkg:res.data.pkg});// set pkg object
          setPackage(res.data.pkg.id);// set selpkg id
        }
        if(_.get(res,'data.success',false)){
          setLoading(false);
        }else{
          if(res.data.message===''){
            window.location.href = process.env.PUBLIC_URL + '/builder';
            //setLoading('You already have scorm purchased, use them.');
          }else{
            setLoading(res.data.message);
          }
        }
      }).catch((e) => {
        //-- do something
        setLoading(e.message);
      });
  }

  useEffect(checkPackageDetails,[]);
  
  const generateOrder = () => {
    setLoading('preparing your order.. please wait..');
    return new Promise((resolve,reject) => {
      axios.post(Utils.apiUrl('order/generate'),{pkg: selectedPackage()},Utils.apiHeaders())
      .then(res => {    
        if(_.get(res,'data.success',false)){
          setLoading("Processing payment..");          
          resolve(res.data.data);
        }else{
          throw(res.data);
        }
      }).catch(reject);
    });
  }


  const displayRazorpay = (orderData) => {

    const options = {
      ...orderData,
      image: `${process.env.PUBLIC_URL}/images/logo-blk.png`,      
      theme: {
          color: "#e0a019",
      },
      handler: (res1) => {
        axios.post(Utils.apiUrl("order/success"), {
          ...orderData,
          svasu_product_id:selectedPackage(),
          orderCreationId: orderData.order_id,
          razorpayPaymentId: res1.razorpay_payment_id,
          razorpayOrderId: res1.razorpay_order_id,
          razorpaySignature: res1.razorpay_signature,
        },Utils.apiHeaders()).then(res2 => {
          if(res2.data.success){
            setLoading("Your payment is successful, redirecting...");
            setPackage(false);            
            window.setTimeout(() => {              
              gotoBuilder();
            },2000);
          }else{
            throw(res2.data.message);
          }
        }).catch(err => {
          setLoading({mode: "danger", msg: err.message});
        });        
      }
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
}

  const confirmOrder = () => {
    Utils.loadJS('https://checkout.razorpay.com/v1/checkout.js','Razorpay SDK failed to load. Are you online?')
    .then(generateOrder)    
    .then(displayRazorpay)
    .catch(err => {
      setLoading({mode: "danger", msg: err.message});
    });    
  }

  const gotoBuilder = () => {
    window.location.href = process.env.PUBLIC_URL + '/builder';
  }

  const renderLoading = () => {
    if(_.isObject(loading)){
      return <Alert variant={loading.mode}>{loading.msg}</Alert>;
    }else{
      return <Alert variant="warning">{loading}</Alert>;
    }
  }

  const renderPayButton = () => {
    let payBtn = <Button className="active px-5 py-2" onClick={confirmOrder}>Pay Now</Button>;
    if(selectedPackage()==='free'){
      payBtn = <Button className="active px-5 py-2" onClick={gotoBuilder}>Build your SCORM</Button>;
    }
    return <>{payBtn}</>;
  }

  const hasEmptyProfileFields = () => {    
    return _.isEmpty(userData.address) || _.isEmpty(userData.country) || _.isEmpty(userData.mobile);
  };
  
  const renderSelectedPackage = () => {    
    const pkg = getPackage();
    return <div className="alert alert-success">
      {_.get(pkg,'name',false)===false && <>No Package selected</>}
      {_.get(pkg,'name',false)!==false && <>
        {pkg.name} <hr />
        {pkg.description}
        <hr />
        Product Cost: {pkg.currency} {pkg.discounted_amount}
      </>}
    </div>;    
  } 


  return <Container className="text-center pb-3">
    <div className="heading mb-4">Let's get started! Build your course.</div>
    <Card className="card-box mx-auto">
      <Card.Body className="px-5">        
        {getPackage() && <h3 className="my-2">Confirm your purchase order</h3>}
        {!getPackage() && <h3 className="my-2">Information!</h3>}
        <p>{getPackage() && renderSelectedPackage()}</p>

        {hasEmptyProfileFields() && <>        
          <hr />
          <h3 className="my-2">Complete your profile</h3>
          <EditProfile />
        </>}
        {loading!==false && renderLoading()}
      </Card.Body>        
      {!hasEmptyProfileFields() && <Card.Footer className="text-center">
        {loading===false && selectedPackage()!==false && renderPayButton()}
   
      </Card.Footer>}
    </Card>    
  </Container>;

}

export default ConfirmPay;